import { openGleap } from '~src/tracking/initGleap';

const FLOW_CONTEXTS = {
  hs_g_new_project_type: {
    message: 'Vorrei richiedere un nuovo tipo di progetto personalizzato.',
    intent: 'new_project_type',
  },
  hs_g_new_format: {
    message: 'Vorrei richiedere un nuovo formato personalizzato.',
    intent: 'new_format',
  },
  hs_g_annuncifunebri_getinfo: {
    message: 'Vorrei ricevere maggiori informazioni su AnnunciFunebri.it.',
    intent: 'annuncifunebri_info',
  },
  hs_g_new_project_event: {
    message: 'Vorrei richiedere un nuovo evento personalizzato.',
    intent: 'new_project_event',
  },
  hs_g_new_template: {
    message: 'Vorrei richiedere un nuovo modello personalizzato.',
    intent: 'new_template',
  },
  hs_g_churn: {
    message: 'Vorrei ricevere assistenza sul mio abbonamento Giotto.',
    intent: 'subscription_support',
  },
  hs_g_removebg_err: {
    message: 'Ho bisogno di assistenza con la rimozione dello sfondo.',
    intent: 'remove_background_error',
  },
};

const triggerChatFlow = (flowOrMessage) => {
  const flow = FLOW_CONTEXTS[flowOrMessage];
  const message =
    flow?.message ||
    (typeof flowOrMessage === 'string' ? flowOrMessage : undefined);

  return openGleap({
    message,
    customData: {
      source: flowOrMessage || 'live_chat_button',
      ...(flow?.intent ? { intent: flow.intent } : {}),
    },
  });
};

export default triggerChatFlow;
